import authentication from "./endpoints/authentication"
import airteam3DViewer from "./endpoints/airteam3DViewer";
import projects from "./endpoints/projects";
import projectFileCategories from "./endpoints/projectFileCategories";
import companies from "@/api/endpoints/companies.js";
import users from "@/api/endpoints/users.js";
import subscriptions from "@/api/endpoints/subscriptions.js";

const API = {
  authentication,
  airteam3DViewer,
  projects,
  projectFileCategories,
  companies,
  users,
  subscriptions,
};

export default API;
